var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgSuccessLogo = function SvgSuccessLogo(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 91,
    viewBox: "0 0 92 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.0001 -0.000488281C20.8654 -0.000488281 0.499512 20.3654 0.499512 45.5001C0.499512 70.6348 20.8654 91.0006 46.0001 91.0006C71.1348 91.0006 91.5006 70.6348 91.5006 45.5001C91.5006 20.3654 71.1348 -0.000488281 46.0001 -0.000488281ZM69.2972 32.9218L40.05 62.3003H40.0281C39.6562 62.6721 38.65 63.5034 37.4906 63.5034C36.6593 63.5034 35.7187 63.044 34.9312 62.2565L22.681 50.0064C22.331 49.6564 22.331 49.1095 22.681 48.7595L26.5748 44.8657C26.7498 44.6907 26.9686 44.6032 27.1873 44.6032C27.4061 44.6032 27.6248 44.6907 27.7998 44.8657L37.5125 54.5783L64.2003 27.6936C64.3753 27.5186 64.594 27.4311 64.8128 27.4311C65.0534 27.4311 65.2722 27.5186 65.4253 27.6936L69.2535 31.653C69.6472 32.0249 69.6472 32.5718 69.2972 32.9218Z",
    fill: "#35FF86"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgSuccessLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/successLogo.65804648a974875656b2609916abb275.svg";